import {blue, green, red} from '@ant-design/colors';
import {PriorityObjType} from '@nxsys/types/models/apps/Todo';

const priorityList: PriorityObjType[] = [
  {id: 4545554, name: 'High', type: 1, color: red[5]},
  {id: 9384234, name: 'Medium', type: 2, color: blue[5]},
  {id: 4354454, name: 'Low', type: 3, color: green[5]},
];
export default priorityList;
